import script from "./NovaForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./NovaForm.vue?vue&type=script&lang=ts&setup=true"

import "./NovaForm.vue?vue&type=style&index=0&id=1aa630f3&lang=scss"

const __exports__ = script;

export default __exports__